export const categories = [
  { slug: 'mingxing-heidong', name: '明星黑料', description: '最新明星八卦、黑料内幕、娱乐圈不为人知的秘密，每日更新劲爆内容', icon: 'ri-star-line' },
  { slug: 'zongyi-chigua', name: '综艺吃瓜', description: '综艺节目幕后花絮、选手内幕、节目争议，吃瓜第一线', icon: 'ri-tv-line' },
  { slug: 'yingshi-jiemi', name: '影视揭秘', description: '电影电视剧拍摄内幕、演员关系、剧组八卦，深扒影视圈', icon: 'ri-film-line' },
  { slug: 'meiri-dasai', name: '每日大赛', description: '每日大赛往期精彩内容回顾，经典爆料合集，不容错过', icon: 'ri-fire-line' },
  { slug: 'hulianwang-gua', name: '互联网瓜', description: '网红博主、直播圈、社交媒体热门事件，互联网吃瓜大全', icon: 'ri-global-line' },
];

export const articles = [
  {
    id: 1,
    title: '某顶流男星深夜密会神秘女子，酒店共度8小时细节全曝光',
    summary: '据知情人士透露，该男星近日在某五星级酒店与一名神秘女子共度长达8小时。监控画面显示两人举止亲密，这与此前其公开的单身人设严重不符。',
    contentHtml: '<p>据知情人士透露，某顶流男星近日在某五星级酒店与一名神秘女子共度长达8小时。监控画面显示两人举止亲密，进入酒店后直至次日凌晨才分别离开。</p><p>该男星近年来一直以"专注事业、不谈感情"的单身形象示人，拥有大量女友粉。此次事件曝光后，粉丝群体反应强烈。</p><p>更令人震惊的是，该神秘女子疑似为某知名导演的前妻，两人此前曾在多个公开场合同框，但均以"普通朋友"相称。如今看来，这段关系远非"普通朋友"那么简单。</p><p>目前该男星方面尚未对此事做出回应。有业内人士分析，此事可能对其正在洽谈的几个代言合同产生重大影响。</p>',
    category: 'mingxing-heidong',
    author: '51爆料编辑部',
    publishDate: '2026-06-30',
    imageSeq: 'article-01',
    imageQuery: 'A%20dramatic%20dark%20cinematic%20scene%20of%20a%20luxury%20hotel%20corridor%20at%20night%2C%20mysterious%20atmosphere%2C%20silhouette%20of%20two%20people%2C%20warm%20dim%20lighting%2C%20noir%20style%2C%20dark%20background%2C%20editorial%20photography%2C%20high%20contrast%2C%20elegant%20composition%2C%20soft%20shadows%2C%20moody%20ambiance%2C%20cinematic%20lighting',
    tag: '独家',
    views: 128500,
    comments: 3421,
  },
  {
    id: 2,
    title: '知名女星税务风波再升级，补缴金额或超2亿，多个代言紧急解约',
    summary: '继此前被曝税务问题后，该女星近日再被查出新的税务漏洞。据税务机关内部人士透露，累计补缴金额可能突破2亿元，多家品牌方已启动紧急解约程序。',
    contentHtml: '<p>继此前被曝税务问题后，该女星近日再被查出新的税务漏洞。据税务机关内部人士透露，累计补缴金额可能突破2亿元。</p><p>消息称，此次查出的问题涉及多个关联公司和境外账户，手法更加隐蔽复杂。税务机关已成立专案组进行深入调查。</p><p>受此影响，该女星代言的多个知名品牌已启动紧急解约程序，预计损失将超过5亿元。其正在拍摄的两部影视作品也被紧急叫停。</p><p>业内人士表示，这可能是近年来娱乐圈涉案金额最大的税务案件之一，或将引发行业新一轮的税务自查风暴。</p>',
    category: 'mingxing-heidong',
    author: '51爆料深度组',
    publishDate: '2026-06-29',
    imageSeq: 'article-02',
    imageQuery: 'A%20dark%20minimalist%20scene%20with%20scattered%20financial%20documents%20on%20a%20glossy%20black%20desk%2C%20dramatic%20lighting%20from%20above%2C%20red%20seal%20stamps%2C%20luxury%20atmosphere%2C%20editorial%20style%2C%20dark%20background%2C%20cinematic%20mood%2C%20high%20contrast%2C%20professional%20composition',
    tag: '独家',
    views: 256300,
    comments: 8921,
  },
  {
    id: 3,
    title: '某综艺节目录制现场爆发激烈冲突，两位嘉宾当场翻脸罢录',
    summary: '据悉，在某热门综艺最新一期录制过程中，两位人气嘉宾因游戏环节产生严重分歧，爆发激烈争吵后双双罢录，节目组紧急叫停拍摄。',
    contentHtml: '<p>据悉，在某热门综艺最新一期录制过程中，两位人气嘉宾因游戏环节的规则理解产生严重分歧。</p><p>现场工作人员透露，争执从口头辩论迅速升级为激烈争吵，双方均使用了不当言辞。其中一位嘉宾愤怒地摔了道具后直接离开录制现场，另一位也紧随其后离场。</p><p>节目组紧急叫停拍摄，导演和制片人分别与两位嘉宾进行了长达两小时的沟通，但截至发稿时仍未达成和解。</p><p>该节目原定于下周六播出，目前尚不清楚此次事件是否会影响正常播出计划。节目组暂未对此事发表官方声明。</p>',
    category: 'zongyi-chigua',
    author: '51爆料综艺组',
    publishDate: '2026-06-28',
    imageSeq: 'article-03',
    imageQuery: 'A%20dark%20TV%20studio%20set%20with%20dramatic%20red%20and%20blue%20stage%20lighting%2C%20empty%20chairs%2C%20tense%20atmosphere%2C%20scattered%20props%20on%20floor%2C%20cinematic%20style%2C%20dark%20background%2C%20editorial%20photography%2C%20high%20contrast%2C%20moody%20lighting',
    tag: '精华',
    views: 189200,
    comments: 5632,
  },
  {
    id: 4,
    title: '揭秘：某热门电影票房造假内幕，午夜幽灵场上座率达100%',
    summary: '本报记者经过数月调查，发现某近期上映的热门影片存在严重的票房造假行为。多地的午夜场次出现"满座"奇观，但实际观影人数寥寥无几。',
    contentHtml: '<p>本报记者经过数月调查，发现某近期上映的热门影片存在严重的票房造假行为。</p><p>调查显示，该影片在全国多个城市的大量午夜场次（凌晨2点至5点）显示满座状态，但记者实地走访发现，多家影院的这些场次实际观影人数寥寥无几，有的甚至空无一人。</p><p>业内人士分析，这种"幽灵场"操作手法的目的是通过虚假票房数据制造影片火爆的假象，从而吸引更多真实观众购票，同时也能在票房排行榜上获得更有利的位置。</p><p>目前相关监管部门已注意到这一现象，或将展开专项调查。该影片的发行方对此予以否认，称"所有数据真实可信"。</p>',
    category: 'yingshi-jiemi',
    author: '51爆料调查组',
    publishDate: '2026-06-27',
    imageSeq: 'article-04',
    imageQuery: 'An%20empty%20movie%20theater%20with%20red%20seats%20in%20darkness%2C%20single%20projector%20beam%20cutting%20through%2C%20eerie%20atmosphere%2C%20cinematic%20noir%20style%2C%20dark%20background%2C%20editorial%20photography%2C%20high%20contrast%2C%20moody%20ambiance',
    tag: '独家',
    views: 312400,
    comments: 12450,
  },
  {
    id: 5,
    title: '某直播平台一姐人设崩塌，私下辱骂粉丝录音曝光，账号已被封禁',
    summary: '一段疑似某直播平台头部女主播私下辱骂粉丝的录音近日在网络上疯传。录音中该主播用极其恶劣的言辞评价为其消费的粉丝，引发全网声讨。',
    contentHtml: '<p>一段疑似某直播平台头部女主播私下辱骂粉丝的录音近日在网络上疯传。</p><p>录音中，该主播用极其恶劣的言辞评价为其大量消费的粉丝，称他们为"傻X""韭菜"，并表示"不割白不割"。这段录音据称是其在私人聚会中的聊天内容，被同场参与者偷偷录制。</p><p>录音曝光后引发全网声讨，大量粉丝表示"心碎"，纷纷要求其道歉。该主播的社交媒体账号评论区已被愤怒的网友攻陷。</p><p>截至发稿，该主播的直播账号已被平台封禁。平台方发布声明称"对此类行为零容忍"。多个品牌方也宣布与其解除合作关系。</p>',
    category: 'hulianwang-gua',
    author: '51爆料互联网组',
    publishDate: '2026-06-26',
    imageSeq: 'article-05',
    imageQuery: 'A%20dark%20scene%20of%20a%20streaming%20studio%20with%20multiple%20screens%20showing%20chat%20messages%2C%20dim%20pink%20and%20purple%20ambient%20lighting%2C%20empty%20gaming%20chair%2C%20cyberpunk%20vibe%2C%20dark%20background%2C%20editorial%20photography%2C%20high%20contrast%2C%20moody%20atmosphere',
    tag: '精华',
    views: 445600,
    comments: 18790,
  },
  {
    id: 6,
    title: '某知名导演被曝长期潜规则新人演员，多位女星勇敢站出来指证',
    summary: '近日有多位女演员联合发声，指控某知名导演在选角过程中存在长期潜规则行为。据其中一位爆料人透露，该导演以"试戏"为名要求演员单独前往酒店。',
    contentHtml: '<p>近日有多位女演员联合发声，指控某知名导演在选角过程中存在长期潜规则行为。</p><p>据其中一位爆料人透露，该导演以"试戏"为名要求演员单独前往酒店房间，并暗示"配合得好就能获得角色"。多位受害者表示，因为害怕被封杀一直不敢公开，但看到越来越多的人站出来后，决定不再沉默。</p><p>目前已有超过10位女演员提供了相关证据，包括聊天记录、酒店开房记录和部分录音。律师表示这些证据已具备法律效力。</p><p>该导演方面通过律师发布声明否认所有指控，称这是"有组织的恶意诽谤"，并表示将通过法律途径维护名誉。但其正在筹备的三部新片已有投资方宣布撤资。</p>',
    category: 'yingshi-jiemi',
    author: '51爆料调查组',
    publishDate: '2026-06-25',
    imageSeq: 'article-06',
    imageQuery: 'A%20dark%20dramatic%20scene%20of%20a%20director%20chair%20on%20an%20empty%20film%20set%2C%20spotlight%20casting%20long%20shadows%2C%20mysterious%20atmosphere%2C%20cinematic%20noir%20style%2C%20dark%20background%2C%20editorial%20photography%2C%20high%20contrast%2C%20minimalist%20composition',
    tag: '独家',
    views: 389700,
    comments: 15620,
  },
  {
    id: 7,
    title: '双顶流地下恋情实锤！两人同款配饰多达17件，行程高度重合',
    summary: '网友扒出两位顶流艺人过去半年内拥有17件同款配饰，且行程轨迹高度重合。更有酒店工作人员爆料称多次看到两人同时入住同一酒店。',
    contentHtml: '<p>网友扒出两位顶流艺人过去半年内拥有17件同款配饰，包括帽子、手链、戒指、项链等，且多件为限量款或定制款，普通渠道难以获取。</p><p>更令人起疑的是，两人的行程轨迹在过去半年内高度重合。同为上海、北京、杭州、成都、三亚等城市的"偶遇"，频率之高已无法用巧合解释。</p><p>此外，有自称某五星级酒店工作人员的网友爆料称，多次看到两人以不同名字同时入住同一酒店同一楼层，且出入时间高度一致。</p><p>两位艺人目前均未对此事做出回应。有娱乐营销专家分析，如果恋情属实，这将是今年娱乐圈最大的新闻之一，对两人的商业价值都将产生重大影响。</p>',
    category: 'mingxing-heidong',
    author: '51爆料编辑部',
    publishDate: '2026-06-24',
    imageSeq: 'article-07',
    imageQuery: 'A%20dark%20romantic%20scene%20with%20two%20matching%20luxury%20bracelets%20on%20black%20velvet%2C%20soft%20moody%20lighting%2C%20mysterious%20atmosphere%2C%20editorial%20photography%2C%20dark%20background%2C%20high%20contrast%2C%20elegant%20minimalist%20composition',
    tag: '精华',
    views: 521800,
    comments: 23450,
  },
  {
    id: 8,
    title: '某选秀节目投票数据造假，内部人员曝冠军早已内定，粉丝百万打水漂',
    summary: '一位自称某选秀节目前工作人员的人士近日发文，详细揭露了节目投票系统的造假流程。据其爆料，最终排名在节目开播前就已经基本确定。',
    contentHtml: '<p>一位自称某选秀节目前工作人员的人士近日发文，详细揭露了节目投票系统的造假流程。</p><p>据其爆料，最终排名在节目开播前就已经基本确定。所谓"观众实时投票"实际上经过后台数据的严重操控，节目组会根据选手背后的经纪公司势力、商业价值等因素分配排名。</p><p>该人士还透露，粉丝为支持偶像投入的投票费用（包括购买赞助商产品获取投票权等）实际上对最终结果影响甚微。据统计，该节目粉丝投票相关消费累计超过5000万元。</p><p>节目组随后发布声明否认所有指控，称投票系统"公平公正公开"，并表示将追究爆料人的法律责任。但该声明并未平息粉丝的愤怒情绪，大量粉丝已在社交平台发起维权。</p>',
    category: 'zongyi-chigua',
    author: '51爆料综艺组',
    publishDate: '2026-06-23',
    imageSeq: 'article-08',
    imageQuery: 'A%20dark%20scene%20of%20a%20talent%20show%20stage%20with%20voting%20screens%20showing%20numbers%2C%20dramatic%20blue%20and%20red%20lighting%2C%20empty%20audience%20seats%2C%20tense%20atmosphere%2C%20cinematic%20style%2C%20dark%20background%2C%20editorial%20photography%2C%20high%20contrast',
    tag: '独家',
    views: 298400,
    comments: 9870,
  },
  {
    id: 9,
    title: '某知名品牌代言人私下使用竞品被抓拍，品牌方要求巨额赔偿',
    summary: '某国际知名品牌的中国区代言人被拍到私下使用竞品产品，照片在社交媒体疯传。品牌方对此极为不满，已向该代言人发出律师函要求赔偿。',
    contentHtml: '<p>某国际知名品牌的中国区代言人被拍到私下使用竞品产品，照片在社交媒体疯传。</p><p>据悉，该代言人与品牌签订的是独家代言协议，年代言费高达2000万元。协议中明确规定代言人在合约期内不得使用、推荐或展示任何竞品产品。</p><p>品牌方对此极为不满，已向该代言人发出律师函，要求按照合约约定进行赔偿，赔偿金额可能高达代言费的三倍。同时品牌方已紧急撤下了所有与该代言人相关的宣传物料。</p><p>该代言人团队回应称照片为"恶意偷拍"，并表示正在与品牌方积极沟通。但品牌方内部人士透露，更换代言人的决定已经基本确定。</p>',
    category: 'mingxing-heidong',
    author: '51爆料商业组',
    publishDate: '2026-06-22',
    imageSeq: 'article-09',
    imageQuery: 'A%20dark%20scene%20of%20luxury%20brand%20products%20shattered%20on%20black%20marble%20floor%2C%20dramatic%20lighting%2C%20broken%20glass%20reflections%2C%20editorial%20photography%2C%20dark%20background%2C%20high%20contrast%2C%20luxury%20noir%20style',
    tag: '精华',
    views: 187600,
    comments: 5430,
  },
  {
    id: 10,
    title: '网曝某知名网红工作室苛待员工：996是福报、拖欠工资、PUA成常态',
    summary: '多位自称某千万粉丝网红工作室前员工的网友近日集体发声，揭露该工作室存在的严重劳动纠纷问题。包括强制加班、拖欠工资、语言暴力等。',
    contentHtml: '<p>多位自称某千万粉丝网红工作室前员工的网友近日集体发声，揭露该工作室存在的严重劳动纠纷问题。</p><p>据爆料，该工作室实行"996"工作制已是常态，经常要求员工通宵加班赶制内容。更令人气愤的是，工作室已连续三个月拖欠员工工资，多名员工被迫离职。</p><p>此外，多位前员工指控该网红经常对员工进行语言暴力和PUA，包括公开羞辱、人身攻击、威胁封杀等。有员工表示离职后出现了严重的心理问题，正在接受心理咨询。</p><p>该网红在直播中回应称这些指控"纯属造谣"，并表示"有些人就是吃不了苦"。这番回应引发更大争议，相关话题迅速登上热搜。当地劳动监察部门表示已介入调查。</p>',
    category: 'hulianwang-gua',
    author: '51爆料互联网组',
    publishDate: '2026-06-21',
    imageSeq: 'article-10',
    imageQuery: 'A%20dark%20office%20scene%20with%20empty%20desks%20under%20dim%20fluorescent%20lighting%2C%20overtime%20atmosphere%2C%20abandoned%20coffee%20cups%2C%20dystopian%20corporate%20vibe%2C%20dark%20background%2C%20editorial%20photography%2C%20high%20contrast%2C%20moody%20cinematic%20style',
    tag: '独家',
    views: 267800,
    comments: 11230,
  },
  {
    id: 11,
    title: '揭秘娱乐圈"阴阳合同"产业链：一线明星一部戏拿三份钱',
    summary: '本报深入调查娱乐圈"阴阳合同"的灰色产业链。据业内人士透露，一线明星通过"大小合同""现金片酬""股权置换"等方式规避税收和片酬限制。',
    contentHtml: '<p>本报深入调查娱乐圈"阴阳合同"的灰色产业链，揭露了这一长期存在的行业潜规则。</p><p>据业内人士透露，一线明星通过"大小合同"（一份公开的低价合同用于备案，一份私下的高价合同作为真实片酬）、"现金片酬"（以现金形式支付部分片酬以避税）、"股权置换"（以公司股份代替部分片酬）等多种方式规避税收和片酬限制。</p><p>以某部近期热播的电视剧为例，女主角对外公布的片酬为3000万元，但实际到手超过8000万元。差额部分通过其关联公司的"咨询费""策划费"等名目走账。</p><p>税务专家表示，这类操作已经触犯了相关法律法规。随着税务监管日益严格，越来越多的明星开始主动补缴税款，但仍有很多人抱着侥幸心理。</p>',
    category: 'yingshi-jiemi',
    author: '51爆料调查组',
    publishDate: '2026-06-20',
    imageSeq: 'article-11',
    imageQuery: 'A%20dark%20scene%20of%20contract%20documents%20with%20red%20seals%20on%20black%20desk%2C%20dramatic%20lighting%2C%20mysterious%20atmosphere%2C%20corporate%20noir%20style%2C%20dark%20background%2C%20editorial%20photography%2C%20high%20contrast%2C%20professional%20composition',
    tag: '独家',
    views: 334500,
    comments: 14560,
  },
  {
    id: 12,
    title: '某男星婚内出轨实锤！酒店监控视频流出，妻子深夜发文暗示离婚',
    summary: '一段疑似某知名男星的酒店监控视频近日流出，画面中该男星与一名年轻女性在凌晨时分共同进入酒店房间。其妻子随后在社交平台发布了一段意味深长的文字。',
    contentHtml: '<p>一段疑似某知名男星的酒店监控视频近日流出，画面中该男星与一名年轻女性在凌晨时分共同进入酒店房间，直至次日中午才分别离开。</p><p>视频曝光后，该男星的妻子在社交平台发布了一段意味深长的文字："十年的信任，一朝崩塌。感谢所有关心我的人，我会坚强。"这段文字虽未直接提及离婚，但被广泛解读为默认了丈夫出轨的事实。</p><p>据知情人士透露，两人已经在私下协商离婚事宜，涉及数亿元的财产分割和子女抚养权问题。该男星的多个代言品牌已紧急暂停了与其的合作。</p><p>该男星方面目前保持沉默，其工作室仅表示"正在核实相关情况，请勿传播不实信息"。</p>',
    category: 'mingxing-heidong',
    author: '51爆料编辑部',
    publishDate: '2026-06-19',
    imageSeq: 'article-12',
    imageQuery: 'A%20dark%20dramatic%20scene%20of%20a%20wedding%20ring%20broken%20in%20half%20on%20black%20surface%2C%20moody%20lighting%2C%20emotional%20atmosphere%2C%20editorial%20photography%2C%20dark%20background%2C%20high%20contrast%2C%20cinematic%20minimalist%20style',
    tag: '精华',
    views: 612300,
    comments: 28940,
  },
];

export const testimonials = [
  {
    id: 1,
    name: '吃瓜群众小A',
    avatar: '瓜',
    comment: '51爆料网真的绝了！每次有大事发生，这里都是第一时间更新，比微博还快！而且料都是实锤的，不像有些营销号只会瞎编。追了两年多了，已经成为我每天的必刷网站。',
  },
  {
    id: 2,
    name: '资深八卦爱好者',
    avatar: '八',
    comment: '作为一枚资深吃瓜人，我可以负责任地说，51爆料网的内容质量在同类网站里绝对是顶级的。不是那种东拼西凑的内容，每篇都能看出是认真调查过的。尤其喜欢往期精华栏目，经典大瓜回顾太爽了！',
  },
  {
    id: 3,
    name: '娱乐圈从业者',
    avatar: '圈',
    comment: '我就在这个圈子里工作，可以告诉大家，51爆料网爆出来的很多料确实是真的。有时候我们自己都还不知道的事情，他们居然先报出来了。不得不佩服他们的信息源，太强了。',
  },
];

export const reviews = [
  {
    id: 1,
    user: '吃瓜达人小王',
    rating: 5,
    content: '这个网站太强了，每日大赛往期内容整理得非常全，有些经典爆料现在看还是那么炸裂！',
    date: '2026-06-30',
  },
  {
    id: 2,
    user: '八卦女王',
    rating: 5,
    content: '独家八卦专区是我的最爱，每篇都是硬核爆料，不是那种标题党。关注51爆料网两年了，从未失望。',
    date: '2026-06-28',
  },
  {
    id: 3,
    user: '好奇宝宝',
    rating: 4,
    content: '内容质量很高，就是更新频率能不能再快一点呀？每天刷新好几次等新瓜哈哈。',
    date: '2026-06-25',
  },
];

export const faqItems = [
  {
    question: '51爆料网的内容来源可靠吗？',
    answer: '51爆料网所有爆料内容均来自多渠道交叉验证，包括内部线人、公开信息整理和行业资深人士供稿。我们坚持"不实锤不发"的原则，确保每一条爆料的真实性和可靠性。',
  },
  {
    question: '如何向51爆料网投稿爆料？',
    answer: '您可以通过网站底部的"联系我们"渠道提交爆料线索。我们承诺对所有爆料人信息严格保密，并根据线索价值提供相应的稿酬奖励。',
  },
  {
    question: '往期精华内容可以免费查看吗？',
    answer: '是的，51爆料网的所有内容（包括往期精华）均完全免费。我们致力于为吃瓜群众打造一个开放、免费的娱乐资讯平台，无需注册即可浏览所有内容。',
  },
  {
    question: '51爆料网每天什么时候更新？',
    answer: '我们的编辑团队全天候工作，热点爆料通常在事件发生后1小时内上线。常规内容每日上午10点和下午4点两个时段集中更新，确保您不错过任何精彩大瓜。',
  },
  {
    question: '如何订阅51爆料网的最新内容？',
    answer: '您可以在网站底部的订阅区域输入您的邮箱地址，订阅后即可第一时间收到最新爆料推送。我们承诺不会向任何第三方泄露您的邮箱信息。',
  },
];